import { styled } from '@mui/system';
import { Box } from '@mui/material';

export const ChartWrapper = styled(Box, {
  shouldForwardProp : (prop) => prop !== 'height',
})(({ height }) => ({
  marginLeft : '-30px',
  '> div'    : {
    width      : 'inherit !important',
    '> canvas' : {
      width  : '-webkit-fill-available !important',
      height : `${height} !important`,
    },
  },
}));
